import {
  ApiSuccess,
  ApiTagTypes,
  BaseCoachingTemplate,
  CoachingTemplate,
  CustomSortingState,
  TemplateStatus,
} from '../../types';
import { apiSlice } from '../api.services';

type CoachingTemplatesParams = {
  sorting?: CustomSortingState;
  status?: TemplateStatus;
  orgId?: string;
};

type CoachingTemplatesForSelectParams = {
  orgId?: string;
  status?: TemplateStatus;
};

type GetCoachingTemplateResponseData = {
  coachingTemplate: CoachingTemplate;
};

type GetCoachingTemplatesResponseData = {
  coachingTemplates: CoachingTemplate[];
};

type GetCoachingTemplatesForSelectResponseData = {
  coachingTemplates: BaseCoachingTemplate[];
};

type GetCoachingTemplateParams = {
  id: string;
  orgId?: string;
};

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCoachingTemplates: builder.query<CoachingTemplate[], CoachingTemplatesParams>({
      query: ({ sorting, status }) => ({
        url: '/coaching-templates',
        params: { ...sorting, status },
      }),
      transformResponse: (response: ApiSuccess<GetCoachingTemplatesResponseData>) => response.data.coachingTemplates,
      providesTags: [ApiTagTypes.COACHING_TEMPLATES],
    }),
    getCoachingTemplatesForSelect: builder.query<BaseCoachingTemplate[], CoachingTemplatesForSelectParams>({
      query: (params) => ({
        url: '/coaching-templates/select',
        params: { status: TemplateStatus.ACTIVE, ...params },
      }),
      transformResponse: (response: ApiSuccess<GetCoachingTemplatesForSelectResponseData>) =>
        response.data.coachingTemplates,
      providesTags: [ApiTagTypes.COACHING_TEMPLATES_FOR_SELECT],
    }),
    getCoachingTemplate: builder.query<CoachingTemplate, GetCoachingTemplateParams>({
      query: ({ id, orgId }) => ({
        url: `/coaching-templates/${id}`,
        params: { orgId },
      }),
      transformResponse: (response: ApiSuccess<GetCoachingTemplateResponseData>) => response.data.coachingTemplate,
      providesTags: (_, __, { id }) => [{ type: ApiTagTypes.COACHING_TEMPLATES, id }],
    }),
  }),
});

export const { useGetCoachingTemplatesForSelectQuery, useGetCoachingTemplatesQuery, useGetCoachingTemplateQuery } =
  enhancedApiSlice;
